import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Output, signal, ViewChild } from '@angular/core';
import { AngularSignaturePadModule, NgSignaturePadOptions, SignaturePadComponent } from '@mineminemine/angular-signature-pad';
import { ButtonModule } from 'primeng/button';
import { Tag } from 'primeng/tag';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AngularSignaturePadModule, ButtonModule, Tag, CommonModule],
    standalone: true, 
    selector: 'app-signature',
    templateUrl: './signature.component.html',
    styles: [
        `
    .pad{
      margin-left:auto !important;
    }
    `
    ]
})
export class SignatureComponent {

  @Output() signatureComplete = new EventEmitter<string>();

  ngOnInit(): void {
    this.windowSize = window.innerWidth;
    this.handleSignatureCanvasSize();
  }
  @ViewChild('signature')
  public signaturePad: SignaturePadComponent;
  @HostListener('window:resize', ['$event'])

  completeSignature(signature:string) {
    this.signatureComplete.emit(signature);
  }

  public windowSize: number;
  public signature:string = '';
  public showActions = signal<boolean>(false);


  signaturePadOptions: NgSignaturePadOptions ;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.windowSize = window.innerWidth;
    this.handleSignatureCanvasSize();
  }

  ngAfterViewInit() {
    this.signaturePad.clear();
  }

  drawComplete() {
    this.showActions.set(true);
  }

  savePad() {
    this.signature = this.signaturePad.toDataURL('data:image/png');
    this.completeSignature(this.signature);
  }

  clearPad() {
    this.showActions.set(false);
    this.signaturePad.clear();
  }

  handleSignatureCanvasSize() {
    const defaultOptions = {
      minWidth: 1,
      penColor: 'rgb(11,43,35)',
      velocityFilterWeight: 0.7,
      backgroundColor: 'rgb(255,255,255)',
      canvasHeight: 500, // default canvasHeight for most cases
  };

  if (this.windowSize < 640) {
      this.signaturePadOptions = {
          ...defaultOptions,
          canvasHeight: 240,
          canvasWidth: 320,
      };
  } else if (this.windowSize <= 768) {
      this.signaturePadOptions = {
          ...defaultOptions,
          canvasWidth: 400,
      };
  } else if (this.windowSize <= 980) {
      this.signaturePadOptions = {
          ...defaultOptions,
          canvasWidth: 480,
      };
  } else if (this.windowSize <= 1200) {
      this.signaturePadOptions = {
          ...defaultOptions,
          canvasWidth: 600,
      };
  } else {
      this.signaturePadOptions = {
          ...defaultOptions,
          canvasWidth: 700,
      };
  }
  }
}
